import React, { useState, useRef, useEffect } from 'react';
import ReactQuill from 'react-quill';
import { FaSave } from "@react-icons/all-files/fa/FaSave"
import Swal from 'sweetalert2';
import 'react-quill/dist/quill.bubble.css';
import 'react-quill/dist/quill.snow.css';
import '../App.css';
import ContextMenu from './ContextMenu';
// REDUX ----------------------------------------------------------------
import { useSelector, useDispatch } from 'react-redux';
import {
    agregarIndividuoALineaTemporal,
    agregarObjetoALineaTemporal,
    updateTextFragmentIndividual,
    agregarRelacion,
    agregarTexto
} from '../features/metadata/MetadataLogic'
import { json } from 'react-router-dom';
//-----------------------------------------------------------------------

export default function QuillEditorComponent(props) {
    // REDUX ----------------------------------------------------------
    // Para obtener y modificar la data del individuo en Redux
    const project = useSelector((state) => state.project)
    const nodes = project.timeLines[props.timeLineID].nodes;

    const priorityCounter1Loc = project.timeLines[props.timeLineID].priorityArr1;
    const priorityCounter2Loc = project.timeLines[props.timeLineID].priorityArr2;
    const priorityCounter3Loc = project.timeLines[props.timeLineID].priorityArr3;

    const dispatch = useDispatch()

    // Varibles for NODES RELATIONSHIP LOGIC
    let node1, node2, relationalType

    function setRelationalTypeDraw(relationalType) {
        switch (relationalType) {
            case ("1"):
                // Relacion con si mismo
                return {
                    "arrows": {
                        "to": {
                            "enabled": true,
                            "type": "triangle",
                        },
                    }, "dashes": false,
                    "width": "1"
                }
            case ("2"):
                // Vinculo relacional fuerte
                return { "width": "8", "dashes": false }
            case ("3"):
                // Vinculo relacional
                return { "dashes": false, "width": "1" }
            case ("4"):
                // Vinculo relacional debil
                return { "dashes": true, "width": "1" }
            case ("5"):
                // Tensión o conflicto
                return { "dashes": true, "width": "1", "label": "X", "font": { "align": "middle" } }
            default:
                break;
        }
    }

    // Referencias para saber cual es el componente del editor
    const quillRef = useRef(null);
    const reactQuillRef = useRef(null);


    // Para detectar cambio de estado de establecer nueva relacion
    const [boolRelationship, setBoolRelationship] = useState("")

    // Palabras están seleccionadas
    const [selectedTextIndividuo, setSelectedTextIndividuo] = useState("");
    let textIndividuo = "";
    const [selectedTextFragmento, setSelectedTextFragmento] = useState("");

    const [selectedObjet, setSelectedObjet] = useState("")
    let textObjet = "";
    let individuoObj;
    let individualObj;

    // Figura geometrica:
    let shape = "";
    // Status del individuo (0 Presente || 1 Ausente)
    let individualStatus = ""
    let borderDashes = false

    // Carga solo los labels desde el store de manera temporal 
    // Sacada de Redux para verificar si ya esta dentro del store global

    let individuosReal = '{'
    let nodesLen = nodes.length
    if (nodesLen > 0) {

        // Definicion de los Individuos
        for (let i = 0; i < nodesLen; i++) {
            if (i < nodesLen - 1) {
                if (nodes[i].type == "individual") {
                    individuosReal += '"' + nodes[i].id + '":' + '"' + nodes[i].label + '",'
                }
            } else {
                if (nodes[i].type == "individual") {
                    individuosReal += '"' + nodes[i].id + '":' + '"' + nodes[i].label + '"}'
                } else {
                    individuosReal = individuosReal.substring(0, individuosReal.length - 1)
                    if (individuosReal == "") {
                        individuosReal = "[]"
                    } else {
                        individuosReal += '}'
                    }
                }
            }
        }
        individuosReal = JSON.parse(individuosReal)
    }

    // Solo labels de los nodos
    const verificarIndividuos = []
    // eslint-disable-next-line
    nodes.map((element) => {
        verificarIndividuos.push(element.label)
    })


    // START Nodes priority lvl ----------------------------------------------
    let priorityLevel;
    const [arrPrio1Length, upgradeArrPrio1Length] = useState(priorityCounter1Loc)
    const [arrPrio2Length, upgradeArrPrio2Length] = useState(priorityCounter2Loc)
    const [arrPrio3Length, upgradeArrPrio3Length] = useState(priorityCounter3Loc)

    const maxLengthPriorities = [project.timeLines[props.timeLineID].priorityArr1,
    project.timeLines[props.timeLineID].priorityArr2,
    project.timeLines[props.timeLineID].priorityArr3]

    function mayor(arr) {
        let mayor = arr[0];
        let i = 1
        arr.forEach(element => {
            if (element > mayor)
                mayor = element
        })
        return mayor;
    }

    let maxLengthPriority = mayor(maxLengthPriorities)





    function setShapeByValue(value) {
        switch (value) {
            case ("1"):
                return "circle"
            case ("2"):
                return "ellipse"
            case ("3"):
                return "database"
            case ("4"):
                return "box"
            case ("5"):
                return "diamond"
            case ("6"):
                return "dot"
            case ("7"):
                return "square"
            case ("8"):
                return "triangle"
            case ("9"):
                return "triangleDown"
            case ("10"):
                return "star"
            case ("11"):
                return "hexagon"
            default: return "ellipse"
        }
    }
    function setAxisPositionByPriorityLevel(priority) {
        switch (priority) {
            case ("1"):
                if (arrPrio1Length == 0) {
                    upgradeArrPrio1Length(arrPrio1Length + 1)
                    return { "x": 0, "y": 0 }
                } else {
                    upgradeArrPrio1Length(arrPrio1Length + 1)
                    return { "x": arrPrio1Length * 100, "y": 0 }
                }
            case ("2"):
                if (arrPrio2Length == 0) {
                    upgradeArrPrio2Length(arrPrio2Length + 1)
                    return { "x": 0, "y": 100, }
                } else {
                    upgradeArrPrio2Length(arrPrio2Length + 1)
                    return { "x": arrPrio2Length * 100, "y": 100 }
                }
            case ("3"):
                if (arrPrio3Length == 0) {
                    upgradeArrPrio3Length(arrPrio3Length + 1)
                    return { "x": 0, "y": 200 }
                } else {
                    upgradeArrPrio3Length(arrPrio3Length + 1)
                    return { "x": arrPrio3Length * 100, "y": 200 }
                }
            default: return 0
        }
    }
    // END Nodes priority lvl   ----------------------------------------------

    // START PARA EL MENU CONTEXTUAL

    function handleCloseMenu() {
        setMenuVisible(false);
    }

    function handleAgregarIndividuo() {
        const selected = quillRef.current.getEditor().getSelection();
        if (selected) {
            setSelectedTextIndividuo((quillRef.current.getEditor().getText(selected.index, selected.length).trim()));
        }
        setMenuVisible(false);
    }

    function handleVincularFragmentoIndividuo() {
        const selected = quillRef.current.getEditor().getSelection();
        if (selected) {
            setSelectedTextFragmento((quillRef.current.getEditor().getText(selected.index, selected.length).trim()));
        }
        setMenuVisible(false);
    }

    function handleAddEdgeByRelationshipType() {
        setBoolRelationship(!boolRelationship)
        setMenuVisible(false);
    }

    // Mostrar el menu contextual del editor de texto
    const handleRightClickCustomContextMenu = (e) => {
        const localX = e.clientX - e.target.offsetLeft;
        const localY = e.clientY - e.target.offsetTop;
        setLocalMousePos({ x: localX, y: localY });
        setMenuVisible(true)
    }

    function handleAgregarObjeto() {
        const selected = quillRef.current.getEditor().getSelection();
        if (selected) {
            setSelectedObjet((quillRef.current.getEditor().getText(selected.index, selected.length).trim()));
        }
        setMenuVisible(false);
    }


    const [localMousePos, setLocalMousePos] = useState({});
    const [menuVisible, setMenuVisible] = useState(false);

    // END DEL MENU CONTEXTUAL

    // EFFECTS -------------------------------------------------------------------------------------------

    // Create node from selected text
    useEffect(() => {
        let selected = quillRef.current.getEditor().getSelection();
        if (selected) {
            setSelectedTextIndividuo((quillRef.current.getEditor().getText(selected.index, selected.length).trim()));
        }

        if (selectedTextIndividuo !== "") {
            Swal.fire({
                // Nombre del individuo a partir del texto
                title: 'Establecer Nuevo Individuo',
                input: 'text',
                inputLabel: 'Identificador de Individuo',
                focusConfirm: false,
                inputValue: selectedTextIndividuo,
                showCancelButton: true,
                confirmButtonText: 'Siguiente',
                cancelButtonText: 'Cancelar',
                inputValidator: (value) => {
                    if (!value) {
                        return 'Hey... El campo no puede estar vacío'
                    } else {
                        textIndividuo = value
                        Swal.fire({
                            title: 'Nivel del Individuo',
                            input: 'select',
                            inputOptions: {
                                1: 'Primer Nivel',
                                2: 'Segundo Nivel',
                                3: 'Tercer Nivel',
                            },
                            inputPlaceholder: 'Selecciona una prioridad',
                            focusConfirm: false,
                            showCancelButton: true,
                            confirmButtonText: 'Siguiente',
                            cancelButtonText: 'Cancelar',
                            inputValidator: (value) => {
                                if (!value) {
                                    return 'Hey... El campo no puede estar vacío'
                                } else {
                                    priorityLevel = value
                                    Swal.fire({
                                        title: 'Asignar figura geométrica',
                                        input: 'select',
                                        inputOptions: {
                                            1: 'Círculo',
                                            2: 'Elipse',
                                            3: 'Base de Datos',
                                            4: 'Caja',
                                            5: 'Rombo',
                                            6: 'Punto',
                                            7: 'Cuadrado',
                                            8: 'Triángulo',
                                            9: 'Triángulo hacia abajo',
                                            10: 'Estrella',
                                            11: 'Hexágono',
                                        },
                                        inputPlaceholder: 'Selecciona una figura',
                                        focusConfirm: false,
                                        showCancelButton: true,
                                        confirmButtonText: 'Siguiente',
                                        cancelButtonText: 'Cancelar',
                                        inputValidator: (value) => {
                                            if (!value) {
                                                return 'Hey... El campo no puede estar vacío'
                                            } else {
                                                shape = setShapeByValue(value)
                                                Swal.fire({
                                                    title: 'Estado inicial del individuo',
                                                    input: "radio",
                                                    inputOptions: {
                                                        0: 'Presente',
                                                        1: 'Ausente'
                                                    },
                                                    // inputPlaceholder: 'Selecciona una figura',
                                                    focusConfirm: false,
                                                    showCancelButton: true,
                                                    confirmButtonText: 'Siguiente',
                                                    cancelButtonText: 'Cancelar',
                                                    inputValidator: (value) => {
                                                        if (!value) {
                                                            return 'Hey... El campo no puede estar vacío'
                                                        } else {
                                                            individualStatus = value

                                                            // ------------------------------------------------------------------------------------------------------------------------------
                                                            // ------------------------------------------------------------------------------------------------------------------------------
                                                            // ------------------------- Modificaciones CON REDUX----------------------------------------------------------------------------

                                                            if (!(verificarIndividuos).includes(selectedTextIndividuo)) {
                                                                Swal.fire({
                                                                    title: 'Elegir un Color',
                                                                    html: '<input id="colorP" type="color"/>',
                                                                    inputLabel: 'Color',
                                                                    focusConfirm: false,
                                                                    confirmButtonText: 'Siguiente',
                                                                    cancelButtonText: 'Cancelar',
                                                                    preConfirm: () => {
                                                                        return [
                                                                            document.getElementById('colorP').value
                                                                        ]
                                                                    }
                                                                }).then((result => {
                                                                    let position = setAxisPositionByPriorityLevel(priorityLevel);
                                                                    if (individualStatus == 1) {
                                                                        borderDashes = true
                                                                    }
                                                                    // dispatch(agregarIndividuo({ label: textIndividuo, shape: shape, color: result.value[0], priority: priorityLevel, status: "1", x: position.x, y: position.y }))
                                                                    dispatch(agregarIndividuoALineaTemporal({ timeLineID: props.timeLineID, label: textIndividuo, shape: shape, color: result.value[0], priority: priorityLevel, status: individualStatus, shapeProperties: { borderDashes: borderDashes }, x: position.x, y: position.y }))
                                                                    // Aplica el formato a las palabras iguales
                                                                    const regex = new RegExp(`\\b${selectedTextIndividuo}\\b`, 'gi');
                                                                    setValueText(valueText.replace(regex, `<span style="background-color:${result.value[0]};">${selectedTextIndividuo}</span>`));
                                                                }))
                                                            } else {
                                                                Swal.fire({
                                                                    title: 'Ya existe este individuo',
                                                                    icon: 'info',
                                                                });
                                                            }
                                                        }
                                                    }
                                                    // ------------------------------------------------------------------------------------------------------------------------------
                                                    // ------------------------------------------------------------------------------------------------------------------------------

                                                })
                                            }

                                        }

                                    })
                                }
                            }
                        })
                    }
                }
            })
            setSelectedTextIndividuo('');
            borderDashes = false;
        }
        // eslint-disable-next-line
    }, [selectedTextIndividuo]);

    // Follow changes in the textEditor
    useEffect(() => {
        if (reactQuillRef.current) {
            quillRef.current = reactQuillRef.current.getEditor();
        }
    }, [reactQuillRef]);


    // Execute addRelationsip
    useEffect(() => {
        if (typeof (boolRelationship) == 'boolean')
            Swal.fire({
                title: 'Establecer Relación entre nodos',
                input: 'select',
                inputLabel: 'Elige el nodo de inicio',
                inputOptions: individuosReal,
                inputPlaceholder: 'Selecciona a un individuo',
                focusConfirm: false,
                showCancelButton: true,
                confirmButtonText: 'Siguiente',
                cancelButtonText: 'Cancelar',
                inputValidator: (value) => {
                    if (!value) {
                        return 'Hey... No seleccionó a ningun individuo'
                    } else {
                        let indReal = individuosReal[value]
                        nodes.forEach(element => {
                            if (element.label == indReal) {
                                node1 = element.id
                            }
                        });
                        // node1 = nodes[value].id
                        Swal.fire({
                            title: 'Establecer Relación entre nodos',
                            input: 'select',
                            inputLabel: 'Elige el nodo de destino',
                            inputOptions: individuosReal,
                            inputPlaceholder: 'Selecciona a un individuo',
                            focusConfirm: false,
                            showCancelButton: true,
                            confirmButtonText: 'Siguiente',
                            cancelButtonText: 'Cancelar',
                            inputValidator: (value) => {
                                if (!value) {
                                    return 'Hey... No seleccionó a ningun individuo'
                                } else {
                                    let indReal2 = individuosReal[value]
                                    nodes.forEach(element => {
                                        if (element.label == indReal2) {
                                            node2 = element.id
                                        }
                                    });
                                    // node2 = nodes[value].id
                                    Swal.fire({
                                        title: 'Establecer Relación entre nodos',
                                        input: 'select',
                                        inputLabel: 'Elige el tipo de relación',
                                        inputOptions:
                                        {
                                            "1": "Relación consigo mismo",
                                            "2": "Vinculo relacional fuerte",
                                            "3": "Vinculo relacional",
                                            "4": "Vinculo relacional débil",
                                            "5": "Relación con tensión o conflicto"
                                        },
                                        inputPlaceholder: 'Selecciona un tipo de relación',
                                        focusConfirm: false,
                                        showCancelButton: true,
                                        confirmButtonText: 'Siguiente',
                                        cancelButtonText: 'Cancelar',
                                        inputValidator: (value) => {
                                            if (!value) {
                                                return 'Hey... No seleccionó a ningun individuo'
                                            } else {
                                                relationalType = setRelationalTypeDraw(value)
                                                let width = "1" && relationalType.width;
                                                let arrows = "" || relationalType.arrows;
                                                let dashes = "" || relationalType.dashes;
                                                let label = "" || relationalType.label;
                                                let font = "" || relationalType.font;

                                                dispatch(agregarRelacion(({
                                                    timeLineID: props.timeLineID,
                                                    from: node1,
                                                    to: node2,
                                                    width: width,
                                                    arrows: arrows,
                                                    dashes: dashes,
                                                    label: label,
                                                    font: font
                                                })))
                                                width = null;
                                            }
                                        }
                                    })
                                }
                            }
                        })
                    }
                }
            })
    }, [boolRelationship])

    // Add text Fragment to a node
    useEffect(() => {
        const selected = quillRef.current.getEditor().getSelection();
        if (selected) {
            setSelectedTextFragmento((quillRef.current.getEditor().getText(selected.index, selected.length).trim()));
        }


        if (selectedTextFragmento !== "") {
            Swal.fire({
                title: 'Establecer Fragmento a Individuo',
                input: 'text',
                inputLabel: 'Fragmento',
                focusConfirm: true,
                inputValue: selectedTextFragmento,
                showCancelButton: true,
                confirmButtonText: 'Siguiente',
                cancelButtonText: 'Cancelar',
                inputValidator: (value) => {
                    if (!value) {
                        return 'Hey... El campo no puede estar vacío'
                    } else {
                        Swal.fire({
                            title: 'Elegir un individuo',
                            input: 'select',
                            inputLabel: 'Individuo',
                            inputOptions: individuosReal,
                            inputPlaceholder: 'Selecciona a un individuo',
                            focusConfirm: false,
                            showCancelButton: true,
                            confirmButtonText: 'Siguiente',
                            cancelButtonText: 'Cancelar',
                            inputValidator: (value) => {
                                if (!value) {
                                    return 'Hey... No seleccionó a ningun individuo'
                                } else {
                                    individualObj = nodes[value]
                                }
                            }
                        }).then((result => {
                            dispatch(updateTextFragmentIndividual(({ timeLineID: props.timeLineID, id: individualObj.id, newTitle: selectedTextFragmento })))
                            // Aplica el formato solo al espacio seleccionado
                            quillRef.current.getEditor().formatText(selected.index, selected.length, 'italic', true);
                        }))
                    }
                    // ------------------------------------------------------------------------------------------------------------------------------
                    // ------------------------------------------------------------------------------------------------------------------------------


                }
            }
            )
            setSelectedTextFragmento('');
        }
        // agregarTextoPopIndividuoID(selectedTextFragmento)
    }, [selectedTextFragmento])


    // START Add Objet
    useEffect(() => {
        let selected = quillRef.current.getEditor().getSelection();
        if (selected) {
            setSelectedObjet((quillRef.current.getEditor().getText(selected.index, selected.length).trim()));
        }

        if (selectedObjet !== "") {
            Swal.fire({
                // Agregar nuevo objeto
                title: 'Establecer Nuevo Objeto',
                input: 'text',
                inputLabel: 'Identificador de Objeto',
                focusConfirm: false,
                inputValue: selectedObjet,
                showCancelButton: true,
                confirmButtonText: 'Siguiente',
                cancelButtonText: 'Cancelar',
                inputValidator: (value) => {
                    if (!value) {
                        return 'Hey... El campo no puede estar vacío'
                    } else {
                        textObjet = value
                        Swal.fire({
                            title: 'Establecer Pertenencia',
                            input: 'select',
                            inputLabel: 'Elige el individuo a quien le pertenezca',
                            inputOptions: individuosReal,
                            inputPlaceholder: 'Selecciona a un individuo',
                            focusConfirm: false,
                            showCancelButton: true,
                            confirmButtonText: 'Confirmar',
                            cancelButtonText: 'Cancelar',
                            inputValidator: (value) => {
                                return new Promise((resolve) => {
                                    individualObj = nodes[value]
                                    dispatch(agregarObjetoALineaTemporal({ timeLineID: props.timeLineID, idFromNode: individualObj.id, fcolor: "white", label: textObjet, x: individualObj.x + 30, y: individualObj.y + 30, shape: "box", color: "#C00000", shapeProperties: { borderDashes: false } }))
                                    const regex = new RegExp(`\\b${selectedObjet}\\b`, 'gi');
                                    setValueText(valueText.replace(regex, `<span style="background-color:#C00000;">${selectedObjet}</span>`));
                                    resolve()
                                })
                            }
                            // (value) => {
                            //     if (!value) {
                            //         return 'Hey... No seleccionó a ningun individuo'
                            //     }
                            // }
                        })
                    }
                }
            })
            individuoObj = ''
            setSelectedObjet('');
            borderDashes = false;
        }
        // eslint-disable-next-line
    }, [selectedObjet]);
    // END Add Objet

    // Modules of Text Editor CONFIG
    const modules = {
        clipboard: {
            matchVisual: false,
        },
        toolbar: false
        // [
        // [{'background': [] }],
        // ['clean']
        // ],
    }

    // ALT + otherKey to set a thing and Show a modal with the flow of the topic
    const handleKeyDown = (event) => {
        // Add Individual
        if (event.altKey && (event.key === "i" || event.key === "I")) {
            const selected = quillRef.current.getEditor().getSelection();
            if (selected) {
                setSelectedTextIndividuo((quillRef.current.getEditor().getText(selected.index, selected.length).trim()));
            }
        }

        if (event.altKey && (event.key === "o" || event.key === "O")) {
            const selected = quillRef.current.getEditor().getSelection();
            if (selected) {
                setSelectedObjet((quillRef.current.getEditor().getText(selected.index, selected.length).trim()));
            }
        }


        // Set text fragment to individual
        if (event.altKey && (event.key === "t" || event.key === "T")) {
            const selected = quillRef.current.getEditor().getSelection();
            if (selected) {
                setSelectedTextFragmento((quillRef.current.getEditor().getText(selected.index, selected.length).trim()));
            }
        }
        // Add Relationship between 2 individuals
        if (event.altKey && (event.key === "p" || event.key === "P")) {
            setBoolRelationship(!boolRelationship);
        }
    };

    // Texto General del editor:
    const [valueText, setValueText] = useState(project.text)

    //Check if project.text (text in redux) has been changed when load a project
    useEffect(() => {
        setValueText(project.text)
    }, [project.text])

    //Sending the text to redux everytime when has changed at quilleditor
    useEffect(() => {
        dispatch(agregarTexto(valueText))
    }, [valueText])

    //LOCALSTORAGE
    const localStorage = window.localStorage
    const [autoSave, setAutoSave] = useState(JSON.parse(localStorage.getItem("autoSave")))
    const [time, setTime] = useState(JSON.parse(localStorage.getItem("time")))

    //Function that transform the project and save on a download of a .json archive
    function handleSave() {
        //Transform the project into a string
        const jsonProject = JSON.stringify(project)
        //Create the blob (Binary Large Object), addign the stringed jsonProject and put the type of
        const blob = new Blob([jsonProject], { type: 'application/json' })
        //Create a URL object for the blob
        const url = URL.createObjectURL(blob)
        // Create a link (a) html element for give that the url of the blob that have the 
        // stringed project information and later put the archive_name in the "download" property 
        // and later call the .click() metodh for do the download
        const a = document.createElement("a")
        a.href = url
        let date = new Date()
        a.download = `${project.projectName}-${date.getFullYear()}_${date.getMonth() + 1}_${date.getDate()}.json`
        a.click()
    }

    //Function to make an interval that save the project every time that X minutes (defined by user) are passed
    useEffect(() => {
        const AutoSaveChecker = setInterval(() => {
            if (autoSave) {
                document.getElementById('btnSaveProject').click()
            }
        }, time * 60000)

        return () => { clearInterval(AutoSaveChecker) }
    }, [])

    return (
        <div onAuxClick={handleRightClickCustomContextMenu} style={{ height: '100%', zIndex: -1 }} >
            {menuVisible && (
                <ContextMenu x={localMousePos.x} y={localMousePos.y}
                    opcion1={handleAgregarIndividuo}
                    opcion2={handleVincularFragmentoIndividuo}
                    opcion3={() => handleAddEdgeByRelationshipType()}
                    opcion4={() => handleAgregarObjeto()}
                    onClose={handleCloseMenu} />
            )}
            <ReactQuill theme="bubble" value={valueText} placeholder="Escribe el texto aquí" onChange={setValueText} onKeyDown={handleKeyDown}
                modules={modules} ref={quillRef}
                id='quilleditor' style={{ height: '100%' }} />
            <div id='btn_saveproject' style={{ backgroundColor: '#001e31', width: '100px', padding: '10px', position: 'fixed', bottom: '5px', right: '5px', borderRadius: '20px', textAlign: 'center', alignContent: 'center', zIndex: 1 }}>
                <button id='btnSaveProject' className="nav-link active" onClick={handleSave} title="Guardar Proyecto" style={{ backgroundColor: 'transparent', color: 'green', fontSize: '20px', alignSelf: 'center' }}><FaSave /> Guardar</button>
            </div>
        </div>
    )
}
